class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.whatsAppEl = null;
    this.giftPopupEl = null;
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      if (this.isCartPage()) {
        return;
      }
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        if (this.isCartPage()) {
          event.preventDefault();
          window.location = this.getCartUrl();
          return;
        }
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  getCartUrl() {
    if (typeof routes !== 'undefined' && routes.cart_url) return routes.cart_url;
    return '/cart';
  }

  isCartPage() {
    const cartUrl = this.getCartUrl().replace(/\/$/, '');
    const path = window.location.pathname.replace(/\/$/, '');
    return path === cartUrl;
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    this.classList.add('animate');
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner) drawerInner.offsetHeight;
    this.classList.add('active');
    this.hideWhatsAppButton();
    this.hideGiftPopupButton();

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    this.showWhatsAppButton();
    this.showGiftPopupButton();
  }

  getWhatsAppSelectorFromWidget() {
    const widget = document.querySelector('[data-wizz-rewards-widget]');
    if (!widget) return '';
    const selector = (widget.getAttribute('data-whatsapp-selector') || '').trim();
    if (!selector || selector.toLowerCase() === 'auto') return '';
    return selector;
  }

  findFixedHost(el) {
    let cur = el;
    for (let i = 0; i < 7 && cur; i += 1) {
      if (cur === this) return null;
      try {
        const pos = window.getComputedStyle(cur).position;
        if (pos === 'fixed') return cur;
      } catch (e) {
        return null;
      }
      cur = cur.parentElement;
    }
    return null;
  }

  pickWhatsAppElement() {
    const customSelector = this.getWhatsAppSelectorFromWidget();
    if (customSelector) {
      try {
        const custom = document.querySelector(customSelector);
        if (custom) return this.findFixedHost(custom) || custom;
      } catch (e) {
        return null;
      }
    }

    const selector =
      'a[href*="wa.me"],a[href*="api.whatsapp.com"],a[href*="whatsapp"],' +
      '[class*="whatsapp"],[id*="whatsapp"],[aria-label*="WhatsApp"],[aria-label*="whatsapp"]';

    const nodes = document.querySelectorAll(selector);
    let best = null;
    let bestScore = -1;

    nodes.forEach((node) => {
      if (!node) return;
      const host = this.findFixedHost(node) || node;
      let rect;
      try {
        rect = host.getBoundingClientRect();
      } catch (e) {
        return;
      }
      if (rect.width < 36 || rect.height < 36) return;
      const score = (rect.bottom * 3) + rect.right;
      if (score > bestScore) {
        bestScore = score;
        best = host;
      }
    });

    return best;
  }

  pickGiftPopupElement() {
    const widget = document.querySelector('[data-wizz-rewards-widget]');
    if (!widget) return null;
    return widget.querySelector('.wizz-rewards-bubble') || widget;
  }

  hideWhatsAppButton() {
    const el = this.pickWhatsAppElement();
    if (!el) return;
    this.whatsAppEl = el;
    if (el.dataset.cartDrawerHidden === '1') return;
    el.dataset.cartDrawerHidden = '1';
    el.dataset.cartDrawerPrevDisplay = el.style.display || '';
    el.dataset.cartDrawerPrevVisibility = el.style.visibility || '';
    el.style.display = 'none';
    el.style.visibility = 'hidden';
  }

  showWhatsAppButton() {
    const el = this.whatsAppEl || document.querySelector('[data-cart-drawer-hidden="1"]');
    if (!el) return;
    const prevDisplay = el.dataset.cartDrawerPrevDisplay;
    const prevVisibility = el.dataset.cartDrawerPrevVisibility;
    if (prevDisplay !== undefined) el.style.display = prevDisplay;
    if (prevVisibility !== undefined) el.style.visibility = prevVisibility;
    delete el.dataset.cartDrawerHidden;
    delete el.dataset.cartDrawerPrevDisplay;
    delete el.dataset.cartDrawerPrevVisibility;
    this.whatsAppEl = null;
  }

  hideGiftPopupButton() {
    const el = this.pickGiftPopupElement();
    if (!el) return;
    this.giftPopupEl = el;
    if (el.dataset.cartDrawerHiddenGift === '1') return;
    el.dataset.cartDrawerHiddenGift = '1';
    el.dataset.cartDrawerPrevDisplay = el.style.display || '';
    el.dataset.cartDrawerPrevVisibility = el.style.visibility || '';
    el.style.display = 'none';
    el.style.visibility = 'hidden';
  }

  showGiftPopupButton() {
    const el = this.giftPopupEl || document.querySelector('[data-cart-drawer-hidden-gift="1"]');
    if (!el) return;
    const prevDisplay = el.dataset.cartDrawerPrevDisplay;
    const prevVisibility = el.dataset.cartDrawerPrevVisibility;
    if (prevDisplay !== undefined) el.style.display = prevDisplay;
    if (prevVisibility !== undefined) el.style.visibility = prevVisibility;
    delete el.dataset.cartDrawerHiddenGift;
    delete el.dataset.cartDrawerPrevDisplay;
    delete el.dataset.cartDrawerPrevVisibility;
    this.giftPopupEl = null;
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const itemCount =
      typeof parsedState?.item_count === 'number'
        ? parsedState.item_count
        : Array.isArray(parsedState?.items)
          ? parsedState.items.length
          : null;
    if (itemCount !== null) {
      this.classList.toggle('is-empty', itemCount === 0);
    }
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    if (typeof window.initCartFeatured === 'function') {
      window.initCartFeatured(this);
    }

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
